"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var featureflip_1 = require("@getgo/featureflip");
var PropTypes = require("prop-types");
var react_1 = require("react");
var Flip = (function (_super) {
    __extends(Flip, _super);
    function Flip(props, context) {
        var _this = _super.call(this, props) || this;
        if (!(context.featureFlip instanceof featureflip_1.default)) {
            throw new Error('Could not find required `featureFlip` object. ' +
                '<FeatureFlipProvider> needs to exist in the component ancestry.');
        }
        _this.state = { now: Date.now() };
        return _this;
    }
    Flip.prototype.componentWillMount = function () {
        var _this = this;
        this.removeListener = this.context.featureFlip.onChange(function () {
            _this.setState({ now: Date.now() });
        });
    };
    Flip.prototype.componentWillUnmount = function () {
        this.removeListener();
    };
    Flip.prototype.render = function () {
        var isEnabled = this.context.featureFlip.isEnabled(this.props.name);
        if (this.props.not ? isEnabled : !isEnabled) {
            return null;
        }
        return react_1.Children.only(this.props.children);
    };
    return Flip;
}(react_1.PureComponent));
Flip.contextTypes = {
    featureFlip: PropTypes.instanceOf(featureflip_1.default),
};
exports.default = Flip;
//# sourceMappingURL=Flip.js.map